module.exports = __webpack_public_path__ + "static/media/es.2c57fe98.svg";